module.exports = __webpack_public_path__ + "img/check.ac6b0400.svg";